import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import type { IHttpCall } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  FetchGeolocationPayloadDTO,
  FetchGeolocationResponseDTO,
} from './fetch-geolocation.types';

type FetchGeolocationOptions = {
  httpCall: IHttpCall;
  requestOverride?: Partial<IHttpRequest<FetchGeolocationPayloadDTO>>;
};

export function fetchGeolocation(
  baseUrl: string,
  payload: FetchGeolocationPayloadDTO,
  options?: FetchGeolocationOptions,
): Promise<IHttpResponse<FetchGeolocationResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<FetchGeolocationPayloadDTO> = {
    url: `${baseUrl}/GeoLocation/${payload.zip}`,
    method: 'GET',
    ...options?.requestOverride,
    schemas: {
      request: FetchGeolocationPayloadDTO,
      response: FetchGeolocationResponseDTO,
    },
  };

  return call(request);
}
